import Vue from 'vue'
import VueRouter from 'vue-router'

import Homepage from './components/Homepage.vue'
import NotFound from './components/NotFound.vue'
import Postingan from './components/Postingan.vue'
import PostinganEvent from './components/PostinganEvent.vue'
import PostinganPodcast from './components/PostinganPodcast.vue'
import SortingEvent from './components/SortingEvent.vue'
import SortingNews from './components/SortingNews.vue'
import SortingPodcast from './components/SortingPodcast.vue'
import Tentang from './components/Tentang.vue'
import ViewGrafik from './components/ViewGrafik.vue'
import GrafikPerBiro from './components/GrafikPerBiro.vue'
import GrafikAll from './components/GrafikAll.vue'
import Biro from './components/Biro.vue'
import Admin from './components/Admin.vue'

//dashboard admin
import DataBiro from './components/DashboardAdmin/DataBiro.vue'
import DataBlog from './components/DashboardAdmin/blog/DataBlog.vue'
import DataPaket from './components/DashboardAdmin/DataPaket.vue'
import DataPelatihanAdmin from './components/DashboardAdmin/DataPelatihan.vue'

//beranda admin
import BerandaBiro from './components/DashboardAdmin/BerandaBiro.vue'
import BerandaBlog from './components/DashboardAdmin/blog/BerandaBlog.vue'
import BerandaPaket from './components/DashboardAdmin/BerandaPaket.vue'
import ViewAllNews from './components/DashboardAdmin/ViewAllNews.vue'
import PersebaranProvinsi from './components/DashboardAdmin/PersebaranProvinsi.vue'
import PersebaranKota from './components/DashboardAdmin/PersebaranKota.vue'
import BerandaReport from './components/DashboardAdmin/BerandaReport.vue'
import BerandaImport from './components/DashboardAdmin/BerandaImport.vue'
import Grafik from './components/DashboardAdmin/Grafik.vue'
import BerandaPelatihanAdmin from './components/DashboardAdmin/BerandaPelatihan.vue'
import DataPodcast from './components/DashboardAdmin/podcast/DataPodcast.vue'
import BerandaPodcast from './components/DashboardAdmin/podcast/BerandaPodcast.vue'
import NewBlog from './components/DashboardAdmin/new-blog/NewBlog.vue'

//dashboard biro
import DataGuru from './components/DashboardBiro/DataGuru.vue'
import DataSiswa from './components/DashboardBiro/DataSiswa.vue'
import DataSekolah from './components/DashboardBiro/DataSekolah.vue'
import DataPersonil from './components/DashboardBiro/DataPersonil.vue'
import DataRegu from './components/DashboardBiro/DataRegu.vue'
import DataBlogBiro from './components/DashboardBiro/blog/DataBlog.vue'
import DataPelatihan from './components/DashboardBiro/DataPelatihan.vue'
import DataSertifikat from './components/DashboardBiro/DataSertifikat.vue'


//beranda biro
import BerandaSiswa from './components/DashboardBiro/BerandaSiswa.vue'
import BerandaSekolah from './components/DashboardBiro/BerandaSekolah.vue'
import BerandaGuru from './components/DashboardBiro/BerandaGuru.vue'
import BerandaPersonil from './components/DashboardBiro/BerandaPersonil.vue'
import BerandaLaporan from './components/DashboardBiro/BerandaLaporan.vue'
import BerandaRegu from './components/DashboardBiro/BerandaRegu.vue'
import BerandaSertifikat from './components/DashboardBiro/BerandaSertifikat.vue'
import BerandaBlogBiro from './components/DashboardBiro/blog/BerandaBlog.vue'
import BerandaPelatihan from './components/DashboardBiro/BerandaPelatihan.vue'
import DaftarKehadiran from './components/DashboardBiro/DaftarKehadiran.vue'
import FormPaket from './components/DashboardBiro/paket/FormPaket.vue'
import ListPaket from './components/DashboardBiro/paket/ListPaket.vue'


// import ViewAllNewsBiro from './components/DashboardBiro/ViewAllNews.vue'

Vue.use(VueRouter)

const session = Vue.prototype.$session

const router = new VueRouter({
    linkActiveClass: 'is-active',
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'Homepage',
            component: Homepage,
            children:[
                {
                    name:'Tentang',
                    path:'/tentang',
                    component:Tentang,
        
                },
                {
                    name:'SortingNews',
                    path:'/sortingnews',
                    component:SortingNews,
                },
                {
                    name:'SortingPodcast',
                    path:'/sortingpodcast',
                    component:SortingPodcast,
                },
                {
                    name:'SortingEvent',
                    path:'/sortingevent',
                    component:SortingEvent,
                },
                {
                    name:'ViewGrafik',
                    path:'/viewgrafik',
                    component:ViewGrafik,
                },
                {
                    name:'GrafikPerBiro',
                    path:'/grafikperbiro',
                    component:GrafikPerBiro,
                },
                {
                    name:'GrafikAll',
                    path:'/grafikall',
                    component:GrafikAll,
                },
            ]
          
        },
        {
            name:'Postingan',
            path:'/news/:id',
            component:Postingan,
        },
        // {
        //     name:'Tentang',
        //     path:'/tentang',
        //     component:Tentang,

        // },
        {
            name:'PostinganEvent',
            path:'/event/:id',
            component:PostinganEvent,
        },
        {
            name:'PostinganPodcast',
            path:'/podcast/:id',
            component:PostinganPodcast,
        },
        // {
        //     name:'SortingEvent',
        //     path:'/sortingevent',
        //     component:SortingEvent,
        // },
        // {
        //     name:'SortingNews',
        //     path:'/sortingnews',
        //     component:SortingNews,
        // },
        // {
        //     name:'ViewGrafik',
        //     path:'/viewgrafik',
        //     component:ViewGrafik,
        // },
        // {
        //     name:'GrafikPerBiro',
        //     path:'/grafikperbiro',
        //     component:GrafikPerBiro,
        // },
        // {
        //     name:'GrafikAll',
        //     path:'/grafikall',
        //     component:GrafikAll,
        // },
        // {
        //     name:'ForgotPassword',
        //     path:'/forgotpassword',
        //     component:ForgotPassword,
        // },
        {
            path:'/admin',
            component:Admin,
            name:'Admin',
            children:
            [
                //============DATA BIRO==========
                 //tambah
               {
                name: 'DataBiro',
                path:'/admin/databiro',
                component: DataBiro,
                },
                //edit
                {
                    name: 'DataBiroEdit',
                    path:'/admin/databiro/:id',
                    component: DataBiro,
                },
                //tabel
                {
                    name: 'BerandaBiro',
                    path:'/admin/berandabiro',
                    component: BerandaBiro,
                },
                   //==========Blog=============
                //beranda
                {
                    name: 'BerandaBlog',
                    path:'/admin/berandablog',
                    component: BerandaBlog,
                },
                //edit
                {
                    name: 'DataBlogEdit',
                    path:'/admin/datablog/:id',
                    component: DataBlog,
                },
                 //tambah   
                 {
                    name: 'DataBlog',
                    path:'/admin/datablog',
                    component: DataBlog,
                },
                {
                    name: 'View All News',
                    path:'/admin/viewallnews',
                    component: ViewAllNews,
                },
                  //==========Import All=============
                //beranda
                {
                    name: 'BerandaImport',
                    path:'/admin/berandaimport',
                    component: BerandaImport,
                },
                // ===========Data Paket============
               //tabel
               {
                name: 'BerandaPaket',
                path:'/admin/berandapaket',
                component: BerandaPaket,
                },
                //tambah
                {
                    name: 'DataPaket',
                    path:'/admin/datapaket',
                    component: DataPaket,
                },
                 //edit
                 {
                    name: 'DataPaketEdit',
                    path:'/admin/datapaket/:id',
                    component: DataPaket,
                },
                   // ===========Reporting============
                // tabel
               {
                name: 'BerandaReport',
                path:'/admin/berandareport',
                component: BerandaReport,
                },
                {
                    name: 'PersebaranProvinsi',
                    path:'/admin/persebaranprovinsi',
                    component: PersebaranProvinsi,
                },
                {
                    name: 'PersebaranKota',
                    path:'/admin/persebarankota',
                    component: PersebaranKota,
                },
                 //============Grafik==========
                {
                    name: 'Grafik',
                    path:'/admin/grafik',
                    component: Grafik,
                },
                   //==========Pelatihan=============
                //beranda
                 //tambah   
                 {
                    name: 'DataPelatihanAdmin',
                    path:'/admin/datapelatihan',
                    component: DataPelatihanAdmin,
                },
                //edit
                {
                    name: 'DataPelatihanEditAdmin',
                    path:'/admin/datapelatihan/:id',
                    component: DataPelatihanAdmin,
                },
                //tabel
                {
                    name: 'BerandaPelatihanAdmin',
                    path:'/admin/berandapelatihan',
                    component: BerandaPelatihanAdmin,
                },
                // ==========PODCAST=========
                {
                    name: 'BerandaPodcast',
                    path:'/admin/berandapodcast',
                    component: BerandaPodcast,
                },
                {
                    name: 'DataBlogEditPodcast',
                    path:'/admin/datapodcast/:id',
                    component: DataPodcast,
                },
                {
                    name: 'DataPodcast',
                    path:'/admin/datapodcast',
                    component: DataPodcast,
                },

                // Menu Blog Baru
                {
                    name: 'NewBlog',
                    path:'/admin/new-blog',
                    component: NewBlog,
                },
            ]
        },
        {
            path:'/biro',
            component:Biro,
            name: 'Biro',
            children:
            [
               // ===========Data Paket============
               //tabel
               {
                name: 'ListPaket',
                path:'/biro/listpaket',
                component: ListPaket,
                },
                //tambah
                {
                    name: 'FormPaket',
                    path:'/biro/formpaket',
                    component: FormPaket,
                },
                 //edit
                 {
                    name: 'FormPaketEdit',
                    path:'/biro/formpaket/:id',
                    component: FormPaket,
                },
                //==========Data Sekolah==========
                //tambah
                {
                    name: 'DataSekolah',
                    path:'/biro/datasekolah',
                    component: DataSekolah,
                },
                //edit
                {
                    name: 'DataSekolahEdit',
                    path:'/biro/datasekolah/:id',
                    component: DataSekolah,
                },
                //tabel
                {
                    name: 'BerandaSekolah',
                    path:'/biro/berandasekolah',
                    component: BerandaSekolah,
                },
                //=========Data Siswa===========
                //tambah   
                {
                    name: 'DataSiswa',
                    path:'/biro/datasiswa',
                    component: DataSiswa,
                },
                //edit
                {
                    name: 'DataSiswaEdit',
                    path:'/biro/datasiswa/:id',
                    component: DataSiswa,
                },
                //tabel
                {
                    name: 'BerandaSiswa',
                    path:'/biro/berandasiswa',
                    component: BerandaSiswa,
                },
                //============Data Guru===========
                 //tambah   
                 {
                    name: 'DataGuru',
                    path:'/biro/dataguru',
                    component: DataGuru,
                },
                //edit
                {
                    name: 'DataGuruEdit',
                    path:'/biro/dataguru/:id',
                    component: DataGuru,
                },
                //tabel
                {
                    name: 'BerandaGuru',
                    path:'/biro/berandaguru',
                    component: BerandaGuru,
                },
                //==========Data Personil=============
                 //tambah   
                 {
                    name: 'DataPersonil',
                    path:'/biro/datapersonil',
                    component: DataPersonil,
                },
                //edit
                {
                    name: 'DataPersonilEdit',
                    path:'/biro/datapersonil/:id',
                    component: DataPersonil,
                },
                //tabel
                {
                    name: 'BerandaPersonil',
                    path:'/biro/berandapersonil',
                    component: BerandaPersonil,
                },
                 //==========Data Regu=============
                 //tambah   
                {
                    name: 'DataRegu',
                    path:'/biro/dataregu',
                    component: DataRegu,
                },
                // {
                //     name: 'AddSiswa',
                //     path:'/biro/addsiswa',
                //     component: AddSiswa,
                // },
                //edit
                {
                    name: 'DataReguEdit',
                    path:'/biro/dataregu/:id',
                    component: DataRegu,
                },
                //tabel
                {
                    name: 'BerandaRegu',
                    path:'/biro/berandaregu',
                    component: BerandaRegu,
                },
                 //==========Data Laporan=============
                //beranda
                {
                    name: 'BerandaLaporan',
                    path:'/biro/berandalaporan',
                    component: BerandaLaporan,
                },
                // ==========Sertifikat=============
               // tambah
                {
                    name: 'BerandaSertifikat',
                    path:'/biro/berandasertifikat',
                    component: BerandaSertifikat,
                },
                {
                    name: 'DataSertifikat',
                    path:'/biro/datasertifikat',
                    component: DataSertifikat,
                },
                {
                    name: 'DataSertifikatEdit',
                    path:'/biro/datasertifikat/:id',
                    component: DataSertifikat,
                },
                  //==========Blog=============
                //beranda
                {
                    name: 'BerandaBlogBiro',
                    path:'/biro/berandablog',
                    component: BerandaBlogBiro,
                },
                //edit
                {
                    name: 'DataBlogEditBiro',
                    path:'/biro/datablog/:id',
                    component: DataBlogBiro,
                },
                
                 //tambah   
                 {
                    name: 'DataBlogBiro',
                    path:'/biro/datablog',
                    component: DataBlogBiro,
                },
                // {
                //     name: 'View All News Biro',
                //     path:'/biro/viewallnews',
                //     component: ViewAllNewsBiro,
                // },
                  //==========Pelatihan=============
                //beranda
                 //tambah   
                 {
                    name: 'DataPelatihan',
                    path:'/biro/datapelatihan',
                    component: DataPelatihan,
                },
                //edit
                {
                    name: 'DataPelatihanEdit',
                    path:'/biro/datapelatihan/:id',
                    component: DataPelatihan,
                },
                //tabel
                {
                    name: 'BerandaPelatihan',
                    path:'/biro/berandapelatihan',
                    component: BerandaPelatihan,
                },

                //kehadiran
                // {
                //     name: 'DaftarKehadiran',
                //     path:'/biro/daftarkehadiran',
                //     component: DaftarKehadiran,
                // },
                // {
                //     name: 'DataKehadiran',
                //     path:'/biro/datakehadiran',
                //     component: DataKehadiran,
                // },
               
                // //tambah
                // {
                //     name: 'DataReport',
                //     path:'/admin/datareport',
                //     component: DataReport,
                // },
                //  //edit
                //  {
                //     name: 'DataReportEdit',
                //     path:'/admin/datareport/:id',
                //     component: DataReport,
                // },
            // {
            //     name: 'ViewSertifikat',
            //     path:'/biro/viewsertifikat',
            //     component: ViewSertifikat,
            // },
                
               
            ]
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound,
        },
        
    ]
    
  })

router.beforeEach((to,from,next)=>{
    //to : Obyek Rute sasaran yang dinavigasi.
    //from :rute saat ini sedang dinavigasi
    //next: argumen yang diberikan ke berikutnya: 
    if(to.name !== 'Homepage' && to.name !== 'Postingan' && to.name !== 'PostinganEvent' && to.name !== 'PostinganPodcast' &&
    to.name !== 'SortingEvent' && to.name !== 'SortingNews' && to.name !== 'SortingPodcast' && to.name !== 'ViewGrafik' 
    && to.name !== 'Tentang' && to.name !== 'GrafikPerBiro' && to.name !== 'GrafikAll' && !session.exists()){
        next({
            name: 'Homepage'
        })
    }else if(to.name === 'Homepage' && session.exists()){//awal login admin ke beranda biro
        next({
            name: 'BerandaBiro'
        })
    }else if(to.name === 'Admin' && !session.has('biro')){//menu admin ke beranda biro oleh admin
        next({
            name: 'BerandaBiro'
        })
    }
    else if(to.name === 'Biro' && !session.has('biro')){//menu biro ke beranda biro oleh admin wkt klik logout
        next({
            name: 'BerandaBiro'
        })
    }else if(to.name === 'Admin' && session.has('biro')){//dari menu admin pilih biro mana lalu ke beranda sekolah
        next({
            name: 'BerandaSekolah'
        })
    }else if(to.name === 'BerandaBiro' && session.has('biro')){//dari beranda biro ke beranda sekolah klo ini dihapus maka bisa lgsg ke biro tnpa klik back to admin
        next({
            name: 'BerandaSekolah'
        })
    }
    else if(to.name === 'Biro' && session.has('biro')){//
        next({
            name: 'BerandaSekolah'
        })
    }
    else{
        next()
    }
    // }else if(to.name === 'Homepage'){
    //     next({
    //         name: 'Admin'
    //     })
    // }
})

export default router

